@use '@logto/core-kit/scss/console-themes' as themes;

.light {
  @include themes.light;
}

.dark {
  @include themes.dark;
}
